<template>
<div>
    <div v-show="!released">
        <div class="counter">

            <div class="message">
                <b>Time until Tarnished:</b>
            </div>

            <br>
            <div class="cd">
                {{days}}
                <br> 
                Day(s) 
            </div>
        

            <div class="cd"> 
                {{hours}}
                <br>
                Hour(s) 
            </div>
       
            <div class="cd">
                {{minutes}}
                <br>
                Min(s) 
            </div>
        
            <div class="cd">
                {{seconds}}
                <br>
                Sec(s)
            </div>

        </div>  
    </div>
    <div v-show="released" class="message" style="padding:150px;">
        <b>Rise, Tarnished!</b>
    </div>
</div>
</template>

<script>


export default {
    props: {
       
    },
    data() {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            released: false
        }
    },
    methods: { 
        calcTimeLeft() {
            var eldenRingRelease =  this.releaseDate
            var now = new Date().getTime()

            var untilTarnished = eldenRingRelease - now
            if (untilTarnished > 0) {
                this.days = Math.floor(untilTarnished/(1000*60*60*24))
                this.hours = Math.floor((untilTarnished % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                this.minutes = Math.floor((untilTarnished % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = Math.floor((untilTarnished % (1000 * 60)) / 1000);
            }
            else {
                
                this.released = true
            }
            
        },
    },
    computed: {
        releaseDate() {
            return new Date("Feb 25, 2022").getTime()
        }
    },
    beforeMount(){
          setInterval(() => {this.calcTimeLeft()},1000)
  }


}

</script>

<style scoped>
 .cd {
    display: inline-block;
    margin: 3vh;
    padding: 3vh;
    border: 0.3vh solid;
    border-radius: 3vh;
    background-color: black;
    opacity: 0.9;
 }

 .counter {
    margin: 3vh;
    border: 0.5vh solid;
    display: inline-block;
    border-radius: 3vh;
    
 }

 .message {
    border: solid;
    border-radius: 3vh;
    background-color: black;
    display: inline-block;
    padding: 3vh;
    margin: 3vh;
    opacity: 0.9;
    outline: none;
 }
</style>
